import React from "react";

import { noop } from "lodash/fp";

import Box from "@mui/material/Box";

import PinExtension from "@app/analytics/assets/PinExtension.png";
import useUserSettings from "@app/analytics/hooks/settings/useUserSettings";
import { Button } from "@app/analytics/onboarding/components/styles";
import {
  StepCardContent,
  StepDescription,
  StepFooter,
  StepHeader,
  StepTitle,
} from "@app/analytics/onboarding/steps/styles";
import { CustomerExperienceOptIn } from "@app/analytics/onboarding/steps/WrapUpStep/wrapUpUpsells";
import ROUTES from "@app/common/routes";

import { Column } from "@rui/Stack";

const WrapUpStepRssContent = ({
  onFinish,
}: {
  onFinish: (event: React.MouseEvent, options: { path: string }) => void;
}) => {
  const { userSettings, updateUserSettings } = useUserSettings();

  const handleToggleCustomerExperienceOptIn = (
    _: React.SyntheticEvent,
    checked: boolean
  ) => {
    updateUserSettings.mutate({ analyticsOptIn: checked }, { onSuccess: noop });
  };

  return (
    <>
      <StepCardContent spacing={3}>
        <StepHeader>
          <StepTitle>Wrap Up</StepTitle>
          <StepDescription>
            You are now ready to use Read Smart Scheduler! For easy access, pin
            the extension to your browser bar.
          </StepDescription>
        </StepHeader>
        <Box
          component="img"
          src={PinExtension}
          sx={{ width: "100%", maxWidth: "650px" }}
        />
      </StepCardContent>
      <StepFooter>
        <Column
          alignItems="center"
          maxWidth="600px"
          padding="24px 0"
          spacing="16px"
        >
          <CustomerExperienceOptIn
            optedIn={userSettings.analyticsOptIn}
            onChange={handleToggleCustomerExperienceOptIn}
          />
          <Button
            endIcon="🎉"
            onClick={(event) => onFinish(event, { path: ROUTES.LANDING_PAGE })}
            primary
          >
            Finish!
          </Button>
        </Column>
      </StepFooter>
    </>
  );
};

export default WrapUpStepRssContent;
